<template>
  <span>
    <slot name="activator" v-bind="{ trigger, uploading }">
      <v-chip class="text-xs-right mx-0">
        {{ label }}
        <v-avatar class="v-icon--right">
          <v-tooltip top :color="themes.candidate.light.tooltip">
            <v-btn
              slot="activator"
              :color="themes.candidate.light.secondaryActionButton"
              :loading="uploading"
              @click="trigger"
              small
              fab
            >
              <v-icon>{{ file ? 'mdi-file-document' : 'mdi-plus' }}</v-icon>
            </v-btn>
            <span>{{ file ? 'Preview or replace document' : 'Upload document' }}</span>
          </v-tooltip>
        </v-avatar>
      </v-chip>
    </slot>

    <input type="file" style="display:none;" ref="fileInput" @change="upload" />

    <v-dialog max-width="600" v-model="previewing">
      <v-card>
        <v-card-title>
          {{ label }} Preview
          <v-spacer />
          <v-btn icon small @click="previewing = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-container fluid grid-list-xs>
          <v-layout row wrap fill-height>
            <v-flex v-if="previewable" d-flex>
              <v-img
                v-if="isImage"
                :height="`${height}px`"
                :style="
                  `background: center no-repeat url('${file.url}'); background-size: contain;`
                "
                class="ma-2"
              />
              <v-img v-else>
                <iframe :src="file.url" :height="height" width="100%" style="border: 0;"></iframe>
              </v-img>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <span class="grey--text text--darken-2">Upload a JPEG, PNG or PDF</span>
          <v-spacer />
          <v-menu v-if="clearable" :close-on-content-click="false" nudge-top="30" top left>
            <v-btn slot="activator" flat icon color="error" class="mr-3">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
            <v-card toolbar dark>
              <v-toolbar color="dark">
                Are you sure?
                <v-spacer />
                <v-btn @click="deleteDocument" color="error" :loading="deleting">
                  Delete
                </v-btn>
              </v-toolbar>
            </v-card>
          </v-menu>
          <v-btn color="primary" @click="$refs.fileInput.click()" :loading="uploading">
            Replace
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
export default {
  props: {
    label: String,
    icon: String,
    file: [Object, File],
    post: String,
    refresh: String,
    clearable: { type: Boolean, default: false },
  },
  data() {
    return {
      uploading: false,
      previewing: false,
      fab: false,
      deleting: false,
    }
  },
  computed: {
    isImage() {
      if (typeof this.file === 'object') {
        return /^image\//.test(this.file.content)
      } else {
        return false
      }
    },
    previewable() {
      return typeof this.file === 'object'
    },
    height() {
      return this.$vuetify.breakpoint.height - 400
    },
  },
  methods: {
    deleteDocument() {
      this.deleting = true
      this.$http
        .delete(this.post)
        .then(response => {
          this.$store.dispatch('snackbarSuccess', 'Document deleted')
          if (this.refresh) this.$store.dispatch(this.refresh).then(() => this.$emit('done'))
        })
        .catch(errors => {
          this.$store.dispatch('snackbarError', 'Document delete failed')
        })
        .finally(() => {
          this.deleting = false
          this.previewing = false
        })
    },
    trigger() {
      if (this.file) {
        // Existing file so preview
        this.preview()
      } else {
        // Nothing so trigger upload
        this.$refs.fileInput.click()
      }
    },
    preview() {
      this.previewing = true
    },
    upload() {
      if (!this.$refs['fileInput']) return

      const formData = new FormData()
      formData.append('document', this.$refs.fileInput.files[0])
      this.uploading = true
      this.$http
        .post(this.post, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(response => {
          this.$store.dispatch('snackbarSuccess', 'Document uploaded')
          if (this.refresh) this.$store.dispatch(this.refresh).then(() => this.$emit('done'))
        })
        .catch(errors => {
          this.$store.dispatch('snackbarError', 'Document upload unsuccessful. Try again or check file extension and size.')
        })
        .finally(() => {
          this.uploading = false
          this.previewing = false
        })
    },
  },
}
</script>
